<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.adapters'), $t('adapters.ebay')]">
        <el-button type="success" size="mini" @click="create"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="red font16 center pd10">
      您的账户可用{{ foreignStores }}国外平台账户，现已加入{{
        usedForeignStores
      }}个
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="items"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="name"
          :title="$t('platform.name')"
          min-width="100"
          ><template v-slot="{ row }">
            {{ row.name }}
            <div class="font10">
              {{ $t("platform.siteId") }}:
              <span v-if="row.siteId != null">{{
                sites.find((u) => u.id == row.siteId).name
              }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="accessToken"
          :title="$t('platform.accessToken')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <span v-if="row.accessToken != null">
              {{ $t("accessTokens.true") }}
            </span>
            <span v-else class="red">{{ $t("accessTokens.false") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="importOrder"
          :title="$t('platform.importOrder')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <span :class="row.importOrder == true ? '' : 'red'">{{
              $t("boolean." + row.importOrder)
            }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="prefix"
          :title="$t('platform.prefix')"
          min-width="90"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('platform.shop')"
          min-width="80"
        />
        <vxe-table-column
          field="storeOwnerId"
          :title="$t('platform.storeOwnerId')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <span v-if="users.find((u) => u.id == row.storeOwnerId) != null">
              {{ users.find((u) => u.id == row.storeOwnerId).name }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="toHandOverAt"
          :title="$t('platform.toHandOverAt')"
          min-width="80"
        />
        <vxe-table-column
          field="authTokenAt"
          :title="$t('platform.authTokenAt')"
          min-width="80"
        />

        <vxe-table-column
          field="mergeBargain"
          :title="$t('platform.mergeBargain')"
          min-width="102"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.mergeBargain) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="percent"
          :title="$t('platform.percent')"
          min-width="80"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="200">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="authorize(row)">{{
              $t("action.authorize1")
            }}</el-button>
            <el-button type="text" size="mini" @click="accessToken(row)">{{
              $t("action.ackAccessToken2")
            }}</el-button>
            <el-button
              v-if="row.subscribedAt == null"
              type="text"
              size="mini"
              :loading="subscribeDoing"
              @click="subscribe(row)"
              >{{ $t("action.subscribe3") }}</el-button
            >
            <el-button
              v-if="row.subscribedAt !== null"
              type="text"
              size="mini"
              @click="clearSubscribe(row)"
              :loading="clearSubscribeDoing"
              >{{ $t("action.cancelSubscribe") }}</el-button
            >
            <div>
              <el-button type="text" size="mini" @click="edit(row)">{{
                $t("text.edit")
              }}</el-button>
              <el-button type="text" size="mini" @click="deleteRow(row)" v-if="row.notifyUrl == null || row.notifyUrl == ''">{{
                $t("text.delete")
              }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="60%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'name'"
              :label="$t('platform.name')"
              :rules="[
                {
                  required: true,
                  validator: validateNameEdit,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.siteId')">
              <el-select size="small" v-model.trim="editObj.siteId">
                <el-option
                  v-for="site in sites"
                  :key="site.id"
                  :label="site.name"
                  :value="site.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="editObj.prefix" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'storeOwnerId'"
              :label="$t('platform.storeOwnerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.storeOwnerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="editObj.storeOwnerId">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'shopId'"
              :label="$t('platform.shop')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.shop')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="editObj.shopId">
                <el-option
                  v-for="shop in shops"
                  :key="shop.id"
                  :label="shop.name"
                  :value="shop.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'toHandOverAt'"
              :label="$t('platform.toHandOverAt')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.toHandOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="editObj.toHandOverAt"
                type="number"
                min="0"
                :placeholder="$t('platform.day')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'importOrder'"
              :label="$t('platform.importOrder')"
            >
              <el-checkbox size="small" v-model.trim="editObj.importOrder" />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :prop="'mergeBargain'"
              :label="$t('platform.mergeBargain')"
            >
              <el-checkbox size="small" v-model.trim="editObj.mergeBargain" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'percent'" :label="$t('platform.percent')">
              <el-input size="small" v-model.trim="editObj.percent" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span class="orange">{{ $t("prompt.toHandOverAtExplain") }}</span>
      <div class="orange" style="margin-left: 35px">
        {{ $t("prompt.mergeBargainExplain") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="60%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'name'"
              :label="$t('platform.name')"
              :rules="[
                { required: true, validator: validateName, trigger: 'blur' },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.siteId')">
              <el-select size="small" v-model.trim="addObj.siteId">
                <el-option
                  v-for="site in sites"
                  :key="site.id"
                  :label="site.name"
                  :value="site.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="addObj.prefix" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'storeOwnerId'"
              :label="$t('platform.storeOwnerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.storeOwnerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="addObj.storeOwnerId">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :prop="'shopId'"
              :label="$t('platform.shop')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.shop')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="addObj.shopId">
                <el-option
                  v-for="shop in shops"
                  :key="shop.id"
                  :label="shop.name"
                  :value="shop.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'toHandOverAt'"
              :label="$t('platform.toHandOverAt')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.toHandOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addObj.toHandOverAt"
                type="number"
                min="0"
                :placeholder="$t('platform.day')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'importOrder'"
              :label="$t('platform.importOrder')"
            >
              <el-checkbox size="small" v-model.trim="addObj.importOrder" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'mergeBargain'"
              :label="$t('platform.mergeBargain')"
            >
              <el-checkbox size="small" v-model.trim="addObj.mergeBargain" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'percent'" :label="$t('platform.percent')">
              <el-input size="small" v-model.trim="addObj.percent" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span class="orange">{{ $t("prompt.toHandOverAtExplain") }}</span>
      <div class="orange" style="margin-left: 35px">
        {{ $t("prompt.mergeBargainExplain") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Cookies from "@/utils/cookies";

import EbayStore from "@/api/adapterEbayStore";
import Tenant from "@/api/tenant";
import User from "@/api/user";
import Shop from "@/api/shop";

export default {
  mixins: [page],
  components: {},
  data() {
    var validateName = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value)) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value) && this.row.name !== value) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    return {
      items: [],
      users: [],
      shops: [],
      tenant: null,
      foreignStores: 0,
      usedForeignStores: 0,
      sites: [
        { id: 0, name: "美国" },
        { id: 2, name: "加拿大" },
        { id: 3, name: "英国" },
        { id: 15, name: "澳大利亚" },
        { id: 77, name: "德国" },
        { id: 71, name: "法国" },
      ],
      // 新增
      addDF: false,
      validateName: validateName,
      addObj: {
        name: null,
        siteId: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        toHandOverAt: null,
        percent: 0,
        mergeBargain: false,
        percent: null,
      },
      saveDoing: false,
      adminDF: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        siteId: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        toHandOverAt: null,
        percent: 0,
        mergeBargain: false,
        percent: null,
      },
      editDoing: false,
      //
      subscribeDoing: false,
      clearSubscribeDoing: false,
    };
  },

  created() {
    const self = this;
    self.loadData();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, shops) {
          if (users.status === 200) {
            self.users = users.data.filter((r) => r.voidAt == null);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    // 授权
    authorize(row) {
      const self = this;
      EbayStore.ackSessionId(row.id).then(function (res) {
        if (res.status === 200) {
          if (res.data != null) {
            window.open(res.data);
          }
        } else {
          self.sysError();
        }
      });
    },
    // 获取令牌
    accessToken(row) {
      const self = this;
      EbayStore.ackAccessToken(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.ackAccessTokenSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 订阅
    subscribe(row) {
      const self = this;
      self.subscribeDoing = true;
      EbayStore.subscribe(row.id).then(function (res) {
        self.subscribeDoing = false;
        if (res.status === 200) {
          self.$message({
            message: res.data.entity,
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 取消订阅
    clearSubscribe(row) {
      const self = this;
      self.clearSubscribeDoing = true;
      EbayStore.clearSubscribe(row.id).then(function (res) {
        self.clearSubscribeDoing = false;
        if (res.status === 200) {
          self.$message({
            message: res.data.entity,
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 新增
    create() {
      const self = this;
      if (self.usedForeignStores >= self.foreignStores) {
        self.$message({
          message: "国外平台数量已达上限，请去联系客服购买",
          type: "warning",
        });
        return;
      }
      self.addObj.name = null;
      self.addObj.prefix = null;
      self.addObj.importOrder = false;
      self.addObj.storeOwnerId = null;
      self.addObj.shopId = null;
      self.addObj.shopName = null;
      self.addObj.toHandOverAt = null;
      self.addObj.percent = null;
      self.addObj.siteId = null;
      self.addObj.mergeBargain = false;
      self.addDF = true;
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (self.addObj.prefix === "") {
            self.addObj.prefix = null;
          }
          self.saveDoing = true;
          EbayStore.create(self.addObj).then(function (res) {
            self.saveDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.usedForeignStores = self.usedForeignStores + 1;
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        EbayStore.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.usedForeignStores = self.usedForeignStores - 1;
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.prefix = row.prefix;
      self.editObj.importOrder = row.importOrder;
      self.editObj.shopId = row.shopId;
      self.editObj.shopName = row.shopName;
      self.editObj.toHandOverAt = row.toHandOverAt;
      self.editObj.percent = row.percent;
      self.editObj.siteId = row.siteId;
      self.editObj.mergeBargain = row.mergeBargain;
      self.addObj.percent = row.percent;
      const selectedUser = self.users.find((u) => u.id === row.storeOwnerId);
      if (selectedUser != null) {
        self.editObj.storeOwnerId = row.storeOwnerId;
      }
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (self.editObj.prefix == "") {
            self.editObj.prefix = null;
          }
          self.editObj.shopName = self.shops.find(
            (s) => s.id === self.editObj.shopId
          ).name;
          self.editDoing = true;
          EbayStore.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    loadData() {
      const self = this;
      self.loadingStart();
      axios
        .all([
          EbayStore.findByTenantId(),
          Tenant.findById(self.Permit.currentTenant().id),
        ])
        .then(
          axios.spread(function (stores, tenant) {
            self.loadingEnd();
            if (stores.status === 200) {
              self.items = stores.data;
            } else {
              self.sysError();
            }
            if (tenant.data.code === 200) {
              self.tenant = tenant.data.entity;
              self.foreignStores = self.tenant.charge.foreignStores;
              self.usedForeignStores = self.tenant.charge.usedForeignStores;
            } else {
              self.sysError();
            }
          })
        );
    },
  },
};
</script>
